/**
 * Service pour les opérations de test de récompenses
 * @module admin/services/rewardsTestService
 */

import { apiGet, apiPost } from '../../../utils/api';

/**
 * Récupère la liste des types de récompenses supportés
 * @returns {Promise<Object>} Liste des types avec success et types
 * @throws {Error} Si la récupération échoue
 */
export const getRewardTypes = async () => {
  return await apiGet('/admin/rewards/test/types');
};

/**
 * Simule une rédemption de récompense
 * @param {string} rewardTitle - Titre de la récompense
 * @param {Object} options - Options de simulation (userInput, username, displayName, userId, rewardId)
 * @returns {Promise<Object>} Résultat de la simulation (success, message, event)
 * @throws {Error} Si la simulation échoue
 */
export const simulateReward = async (rewardTitle, options = {}) => {
  return await apiPost('/admin/rewards/test/simulate', {
    rewardTitle,
    ...options,
  });
};

/**
 * Récupère la liste des récompenses Twitch avec leurs IDs
 * @param {boolean} onlyManageable - Si true, retourne uniquement les récompenses gérables
 * @returns {Promise<Object>} Liste des récompenses avec success, rewards, count
 * @throws {Error} Si la récupération échoue
 */
export const getRewards = async (onlyManageable = false) => {
  const params = onlyManageable ? '?onlyManageable=true' : '';
  return await apiGet(`/admin/rewards/test/rewards${params}`);
};
